<div class="search-subscription-form" [formGroup]="form">
  <div class="search-subscription-form__row"
       *ngIf="!canSubmitForm"
  >
    <div class="form-cookie-message">
      <div class="form-cookie-message__icon">
        <i class="material-icon material-icon--two-tone">privacy_tip</i>
      </div>
      
      <p class="form-cookie-message__text">
          {{ 'searchSubscription.cookieMessage.description' | i18n }}
      </p>

      <div class="form-cookie-message__button">
          <button 
            class="form-cookie-message-button" 
            type="button"
            (click)="openCookieSettings()"
          >
            {{ 'searchSubscription.cookieMessage.button' | i18n }}
          </button>
      </div>
    </div>
  </div>

  <div class="search-subscription-form__row">
    <label
      for="form_first_name"
      class="mdc-text-field mdc-text-field--outlined"
    >
      <span class="mdc-notched-outline">
        <span class="mdc-notched-outline__leading"></span>
        <span class="mdc-notched-outline__notch">
          <span class="mdc-floating-label">
            {{ 'searchSubscription.form.firstName' | i18n }}
          </span>
        </span>
        <span class="mdc-notched-outline__trailing"></span>
      </span>

      <input
        type="text"
        id="form_first_name"
        class="mdc-text-field__input"
        required
        formControlName="firstName"
      />
    </label>

    <div class="mdc-text-field-helper-line" *ngIf="isFirstNameInvalid">
      <div
        class="mdc-text-field-helper-text mdc-text-field-helper-text--persistent mdc-text-field-helper-text--error"
      >
        {{ 'searchSubscription.form.firstNameRequired' | i18n }}
      </div>
    </div>
  </div>

  <div class="search-subscription-form__row">
    <label for="form_last_name" class="mdc-text-field mdc-text-field--outlined">
      <span class="mdc-notched-outline">
        <span class="mdc-notched-outline__leading"></span>
        <span class="mdc-notched-outline__notch">
          <span class="mdc-floating-label">
            {{ 'searchSubscription.form.lastName' | i18n }}
          </span>
        </span>
        <span class="mdc-notched-outline__trailing"></span>
      </span>

      <input
        type="text"
        id="form_last_name"
        required
        class="mdc-text-field__input"
        formControlName="lastName"
      />
    </label>

    <div class="mdc-text-field-helper-line" *ngIf="isLastNameInvalid">
      <div
        class="mdc-text-field-helper-text mdc-text-field-helper-text--persistent mdc-text-field-helper-text--error"
      >
        {{ 'searchSubscription.form.lastNameRequired' | i18n }}
      </div>
    </div>
  </div>

  <div class="search-subscription-form__row">
    <label for="form_email" class="mdc-text-field mdc-text-field--outlined">
      <span class="mdc-notched-outline">
        <span class="mdc-notched-outline__leading"></span>
        <span class="mdc-notched-outline__notch">
          <span class="mdc-floating-label">
            {{ 'searchSubscription.form.email' | i18n }}
          </span>
        </span>
        <span class="mdc-notched-outline__trailing"></span>
      </span>

      <input
        type="email"
        id="form_email"
        class="mdc-text-field__input"
        required
        formControlName="email"
      />
    </label>

    <div class="mdc-text-field-helper-line" *ngIf="isEmailInvalid">
      <div
        class="mdc-text-field-helper-text mdc-text-field-helper-text--persistent mdc-text-field-helper-text--error"
      >
        {{ 'searchSubscription.form.emailRequired' | i18n }}
      </div>
    </div>
  </div>

  <div class="search-subscription-form__separator"></div>

  <div class="search-subscription-form__row">
    <div class="form-row">
      <div class="mdc-form-field search-subscription-form__checkbox">
        <lib-checkbox
          [id]="'form_newsletter'"
          formControlName="subscribeToNewsletter"
        ></lib-checkbox>

        <label
          for="form_newsletter"
          class="search-subscription-form__checkbox-label"
        >
          {{ 'searchSubscription.form.receiveNewsletter' | i18n }}
        </label>
      </div>

      <div
        class="form-row__help_text form-row__help_text--after-checkbox"
        [innerHTML]="'searchSubscription.form.newsletterHint' | i18n"
      ></div>
    </div>

    <div class="form-row">
      <div class="mdc-form-field">
        <lib-checkbox
          [id]="'form_terms'"
          formControlName="terms"
        ></lib-checkbox>

        <label
          for="form_terms"
          class="search-subscription-form__checkbox-label"
          [innerHTML]="'searchSubscription.form.acceptPrivacyHint' | i18n"
        >
        </label>
      </div>
    </div>
  </div>
</div>
